export type UrlPlaceholderValues = Record<string, string | number>;

/**
 * Builds a URL by combining a base segment with an endpoint template and replacing any placeholder tokens.
 *
 * @param {string} base - Base URL or path segment
 * @param {string} endpoint - Endpoint template that may include placeholders in the format `:placeholder`.
 * @param {string} replacements - Optional map containing placeholder values.
 * @returns {string} Resolved URL with placeholders replaced.
 */
export function buildUrl(base: string, endpoint: string, replacements?: UrlPlaceholderValues): string {
  let resolvedEndpoint = endpoint;

  if (replacements) {
    for (const [key, value] of Object.entries(replacements)) {
      const replacementValue = encodeURIComponent(String(value));
      // eslint-disable-next-line security/detect-non-literal-regexp
      resolvedEndpoint = resolvedEndpoint.replaceAll(new RegExp(String.raw`:${key}\b`, 'g'), replacementValue);
    }
  }

  const trimmedBase = base.endsWith('/') ? base.slice(0, -1) : base;
  const normalizedEndpoint = resolvedEndpoint.startsWith('/') ? resolvedEndpoint : `/${resolvedEndpoint}`;

  return `${trimmedBase}${normalizedEndpoint}`;
}
